/* eslint-disable no-case-declarations */
import { config } from 'affiny-core/env';
import { EReflistChapterName } from 'affiny-core/modules/api/repositories/reflists/reflists.types';
import { EAuthActionType, TAuthAction } from 'affiny-core/modules/auth/actions';
import { ActionsOfType } from 'affiny-core/modules/helpers';
import { RoutesNames } from 'affiny-desktop/src/routes/routes-names';
import { createBrowserHistory } from 'history';
import { all, call, takeLatest } from 'redux-saga/effects';

function* redirectFastForwardSaga(
  action: ActionsOfType<TAuthAction, EAuthActionType.FAST_FORWARD_NAVIGATE>
) {
  const history = createBrowserHistory({
    forceRefresh: true,
    basename: config.env.publicBasePath,
  });
  const env = process.env.NODE_ENV;
  let pathname;

  switch (true) {
    case action.payload.route.goHome:
      const needHomeRedirect =
        history.location.pathname.startsWith(
          RoutesNames.ProfileCapturePrefix
        ) || history.location.pathname === '/loginDebug';

      if (needHomeRedirect) {
        yield call(history.push, {
          pathname: RoutesNames.Home,
        });
      }
      break;

    case action.payload.route.goWelcome:
    case action.payload.route.goLogin:
      // TODO for JPA: try to hide logout "button" on "/loginDebug" page
      // So, try to remove this "if".
      if (history.location.pathname !== RoutesNames.LoginDebug) {
        if (env === 'development') {
          yield call(history.push, {
            pathname: RoutesNames.LoginDebug,
          });
        } else {
          yield call([window.location, 'replace'], RoutesNames.Login);
        }
      }
      break;

    case action.payload.route.startProfileCapture:
      pathname = `${RoutesNames.ProfileCapturePrefix}/${EReflistChapterName.SEARCH}/0`;

      if (history.location.pathname !== pathname) {
        yield call(history.push, {
          pathname,
        });
      }
      break;

    case action.payload.route.goQuestion:
      const chapterLabel =
        action.payload.params && action.payload.params.chapterLabel;
      const questionIndex =
        action.payload.params && action.payload.params.questionIndex;

      pathname = `${RoutesNames.ProfileCapturePrefix}/${chapterLabel}/${questionIndex}`;

      if (history.location.pathname !== pathname) {
        yield call(history.push, {
          pathname,
        });
      }
      break;

    case action.payload.route.goToNextChapter:
      const nextChapterLabel =
        action.payload.params && action.payload.params.chapterLabel;

      pathname = `${RoutesNames.ProfileCapturePrefix}/${nextChapterLabel}/0`;

      if (history.location.pathname !== pathname) {
        yield call(history.push, {
          pathname,
        });
      }
      break;

    case action.payload.route.goUploadPicture:
      if (
        history.location.pathname !== RoutesNames.ProfileCaptureProfilePicture
      ) {
        yield call(history.push, {
          pathname: RoutesNames.ProfileCaptureProfilePicture,
        });
      }
      break;

    case action.payload.route.goAnnounce:
      if (history.location.pathname !== RoutesNames.ProfileCaptureAnnounce) {
        yield call(history.push, {
          pathname: RoutesNames.ProfileCaptureAnnounce,
        });
      }
      break;
    case action.payload.route.goXsell:
      if (
        history.location.pathname !==
        RoutesNames.ProfileCaptureCrossSellLegalCheck
      ) {
        yield call(history.push, {
          pathname: RoutesNames.ProfileCaptureCrossSellLegalCheck,
        });
      }
      break;
    case action.payload.route.goSafetyTips:
      if (history.location.pathname !== RoutesNames.ProfileCaptureSafetyTips) {
        yield call(history.push, {
          pathname: RoutesNames.ProfileCaptureSafetyTips,
        });
      }
      break;
    case action.payload.route.goWhyPremium:
      if (history.location.pathname !== RoutesNames.WhyPremium) {
        yield call(history.push, {
          pathname: RoutesNames.WhyPremium,
        });
      }
      break;
  }
}

export function* authSaga() {
  yield all([
    takeLatest(EAuthActionType.FAST_FORWARD_NAVIGATE, redirectFastForwardSaga),
  ]);
}
